<template>
  <div class="ml-actions">
    <medkitlogProofAction
      :item="item"
      :config="config"
      @reloadData="$emit('reloadData')"
    />
    <v-tooltip bottom v-if="canCreateHere">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="copyItem(item)"
          data-cy="copy"
          >content_copy</v-icon
        >
      </template>
      <span>{{ $t("medkitlogs.copyMedkitlog") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="!isReadOnlyUser">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="editItem(item)"
          data-cy="edit"
        >
          edit</v-icon
        >
      </template>
      <span>{{ $t("medkitlogs.editMedkitlog") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="canDeleteHere">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="openDeleteDialog(item)"
          data-cy="delete"
        >
          delete</v-icon
        >
      </template>
      <span>{{ $t("medkitlogs.deleteMedkitlog") }}</span>
    </v-tooltip>
    <deleteDialog
      @triggerDelete="deleteItem"
      :item="item"
      :deleteDialog="deleteDialog"
    />
  </div>
</template>

<script>
import medkitlogProofAction from "./medkitlogProofAction.vue";
import deleteDialog from "../../_utils/dataTableHelpers/actions/deleteDialog.vue";
export default {
  props: ["item", "config"],
  components: {
    medkitlogProofAction,
    deleteDialog,
  },
  data: () => ({
    deleteDialog: {
      open: false,
      title: "medkitlogs.deleteMedkitlog",
      description: "",
    },
  }),
  methods: {
    editItem(item) {
      this.$router.push({
        name: "medkitlogForm",
        params: { id: item.id, mode: "edit" },
      });
    },
    copyItem(item) {
      this.$router.push({
        name: "medkitlogForm",
        params: { id: item.id, mode: "copy" },
      });
    },
    openDeleteDialog(item) {
      this.deleteDialog.open = true;
      this.deleteDialog.description = this.$t("medkitlogs.deleteTitleLong", {
        title: item.name,
      });
    },
    deleteItem(item) {
      this.$store.dispatch("deleteMedkitlog", item).then(() => {
        this.reloadDataFunc();
        this.deleteDialog.open = false;
      });
    },
    reloadDataFunc() {
      this.$emit("reloadData");
    },
  },
};
</script>

<style scoped>
.ml-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
}
</style>
